import { useCallback } from 'react'
import useLanguagesV2 from './useLanguagesV2'

export default function useTranslations() {
  const { language, languageDefault, languageFR } = useLanguagesV2()

  const t = useCallback(
    (key, { values, valueDefault } = {}) => {
      let value = language?.translations[key] || languageDefault?.translations[key] || languageFR?.translations[key] || valueDefault
      if (value) {
        if (values) {
          for (let i = 0; i < values.length; i += 1) {
            const curr = values[i]
            value = value.replace(`$${i + 1}`, curr)
          }
        }
        return value
      }

      return `[${key}]`
    },
    [language, languageDefault, languageFR]
  )

  return { t }
}
